/**
 * iter294d — Formül / Ar-Ge revizyonları arasındaki hammadde farklarını
 * insan-okunur cümlelere çevirir. Backend her revizyonda `lines` snapshot'ı
 * saklıyor (rd_sample_revisions.snapshot.lines veya formulas.lines) — bu
 * yardımcı iki snapshot arasındaki farkı hesaplar.
 *
 * Örnek çıktı:
 *   { kind: "add",    text: "+%1 Niacinamide eklendi" }
 *   { kind: "remove", text: "-%1 Kem EHG çıkarıldı" }
 *   { kind: "change", text: "Kem EHG: %2 → %1" }
 */

const keyOf = (l) => (l?.material_id || (l?.material_name || "").toLowerCase().trim()) || null;

export function fmtPct(v) {
  const n = Number(v || 0);
  if (!isFinite(n)) return "%0";
  // Tam sayı ise ondalık yok, aksi halde en fazla 2 basamak (trailing zero'lar kırpılır)
  if (Math.abs(n - Math.round(n)) < 1e-9) return `%${Math.round(n)}`;
  const s = n.toFixed(2).replace(/0+$/, "").replace(/\.$/, "");
  return `%${s}`;
}

export function diffRevisionLines(oldLines = [], newLines = []) {
  const oldMap = new Map();
  const newMap = new Map();
  (oldLines || []).forEach((l) => { const k = keyOf(l); if (k) oldMap.set(k, l); });
  (newLines || []).forEach((l) => { const k = keyOf(l); if (k) newMap.set(k, l); });

  const changes = [];
  // Eklenen hammaddeler
  for (const [k, ln] of newMap) {
    if (!oldMap.has(k)) {
      const name = ln.material_name || "(isimsiz)";
      changes.push({ kind: "add", text: `+${fmtPct(ln.percentage)} ${name} eklendi` });
    }
  }
  // Silinen hammaddeler
  for (const [k, ln] of oldMap) {
    if (!newMap.has(k)) {
      const name = ln.material_name || "(isimsiz)";
      changes.push({ kind: "remove", text: `-${fmtPct(ln.percentage)} ${name} çıkarıldı` });
    }
  }
  // Değişen yüzdeler
  for (const [k, oldLn] of oldMap) {
    const newLn = newMap.get(k);
    if (!newLn) continue;
    const oldP = Number(oldLn.percentage || 0);
    const newP = Number(newLn.percentage || 0);
    if (Math.abs(oldP - newP) > 0.001) {
      const name = newLn.material_name || oldLn.material_name || "(isimsiz)";
      changes.push({ kind: "change", text: `${name}: ${fmtPct(oldP)} → ${fmtPct(newP)}` });
    }
  }
  return changes;
}

/** Küçük UI yardımcısı — diff maddelerini renkli chip listesine çevirir. */
export function diffKindClass(kind) {
  if (kind === "add") return "text-emerald-700 bg-emerald-50 border-emerald-200";
  if (kind === "remove") return "text-red-700 bg-red-50 border-red-200";
  return "text-amber-700 bg-amber-50 border-amber-200"; // change
}
